import {ssrLazy} from 'ssr/lazy';

export const EamHeroMapLazy = ssrLazy(() => import(/* webpackChunkName: "eamHeroMap" */ '.'));
